<template>
    <div>
        <transition name="slide-fade">
            <form id="form-cont" :action="rutaformulario" method="POST" class="mt-3 zp-errors-border-all" v-on:submit="sendForm" v-show="mostrarFormulario">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="tipologia" :value="form.tipologia">
                <input type="hidden" name="email_contacto" :value="form.email_contacto">
                <div class="form-group">
                    <input type="text" name="nombre" placeholder="Nombre Completo"
                        :class="!$v.form.nombre.$anyError? 'form-control zp-input-formulario': 'form-control zp-input-formulario zp-form-error'"
                        v-model="$v.form.nombre.$model" @keypress="onlyLetters" required autocomplete="off">
                    <div class="zp-texto-error p-0" v-if="$v.form.nombre.$dirty">
                        <span v-if="!$v.form.nombre.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Campo necesario
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" name="rut" placeholder="R.U.N."
                        :class="!$v.form.rut.$anyError? 'form-control zp-input-formulario': 'form-control zp-input-formulario zp-form-error'"
                        v-model="$v.form.rut.$model" required autocomplete="off"
                        maxlength="12"
                        v-rut:live
                        >
                    <div class="zp-texto-error p-0" v-if="$v.form.rut.$dirty">
                        <span v-if="!$v.form.rut.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Campo necesario
                        </span>
                        <span v-if="(!$v.form.rut.rutValidation || !$v.form.rut.minLength) && $v.form.rut.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            R.U.N. inválido
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <input type="email" name="email" placeholder="Email"
                        :class="!$v.form.email.$anyError? 'form-control zp-input-formulario': 'form-control zp-input-formulario zp-form-error'"
                        v-model="$v.form.email.$model" required>
                    <div class="zp-texto-error p-0" v-if="$v.form.email.$dirty">
                        <span v-if="!$v.form.email.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Campo necesario
                        </span>
                        <span v-else-if="!$v.form.email.email" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Debe ser un email valido
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" name="telefono" maxlength="9" placeholder="+56 9"
                        :class="!$v.form.telefono.$anyError? 'form-control zp-input-formulario': 'form-control zp-input-formulario zp-form-error'"
                        v-model="$v.form.telefono.$model" @keypress="onlyNumber" required>
                    <div class="zp-texto-error p-0" v-if="$v.form.telefono.$dirty">
                        <span v-if="!$v.form.telefono.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Campo necesario
                        </span>
                        <span v-if="!$v.form.telefono.minLength" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Formato inválido
                        </span>
                    </div>
                </div>
                <div class="form-group zp-input-gris" v-if="tipologias.length > 0">
                    <div class="zp-cotizador-input-label">
                        Selecciona la tipología
                    </div>
                    <v-select-c
                        v-model="$v.form.tipologia.$model"
                        placeholder="Selecciona la tipología"
                        :options="tipologias"
                        :class="!$v.form.tipologia.$anyError ? '' : 'zp-select-form-error'">
                        <div slot="no-options">
                            No se encontraron tipos
                        </div>
                    </v-select-c>
                    <div class="zp-texto-error p-0" v-if="$v.form.tipologia.$dirty">
                        <span v-if="!$v.form.tipologia.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Campo necesario
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <textarea name="mensaje" id="mensaje" rows="3" placeholder="Mensaje"
                        :class="!$v.form.mensaje.$anyError? 'form-control zp-input-formulario': 'form-control zp-input-formulario zp-form-error'"
                        v-model="$v.form.mensaje.$model"/>
                    <div class="zp-texto-error" v-if="$v.form.mensaje.$dirty">
                        <span v-if="!$v.form.mensaje.required" class="zp-error-span">
                            <i class="fas fa-exclamation-circle text-danger"></i>
                            Campo necesario
                        </span>
                    </div>
                </div>
                <button type="submit" class="btn btn-block zp-btn-formulario mt-4" :disabled="$v.form.$invalid">
                    {{btnText}}
                </button>
            </form>
        </transition>
    </div>
</template>

<script>
    import { required, minLength, email , requiredIf} from 'vuelidate/lib/validators'
    import { rutValidator, rutInputDirective } from "vue-dni";
    Vue.directive("rut", rutInputDirective);

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    Vue.component('v-select-c', vSelect);

    export default {
        name: "FormularioContactoProyecto",
        props: [
            "rutaformulario",
            "unidades",
        ],
        data: function() {
            return  {
                mostrarFormulario:false,
                formularioCargando:false,
                btnText: "Enviar",
                form:{
                    nombre:"",
                    email:"",
                    email_contacto:"",
                    telefono:"",
                    mensaje:"",
                    tipologia:"",
                    rut:"",
                },
                tipologias:[],
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        validations: {
            form:{
                nombre:{
                    required,
                },
                email:{
                    required,
                    email
                },
                telefono:{
                    required,
                    minLength: minLength(9),
                },
                mensaje:{
                    required
                },
                tipologia:{
                    required:
                        requiredIf(function(){
                            return this.tipologias.length > 0
                        })
                },
                rut:{
                   required,
                    rutValidation: rutValidator,
                    minLength: minLength(9),
                },
            }
        },
        watch: {
        },
        mounted() {
            this.calculaTipologias();
            document.addEventListener("selecciona-contacto", (e) => { 
                if(e.detail){
                    if(e.detail.email){
                        this.mostrarFormulario = true;
                        this.form.email_contacto = e.detail.email;
                    }
                }
            });
        },
        methods:{
            calculaTipologias () {
                this.unidades.map((p) => {
                    if (this.tipologias.indexOf(p.dormitorios + " Dorm " + p.banos + " Baños") === -1) {
                        this.tipologias.push(
                            p.dormitorios + " Dorm " + p.banos + " Baños"
                        );
                    }
                });
            },
            sendForm () {
                if(!this.formularioCargando){
                    this.formularioCargando = true;
                    this.btnText = "Enviando...";
                    return true;
                }
                event.preventDefault();
                return false; 
            },
            onlyNumber ($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                    $event.preventDefault();
                }
            },
            onlyLetters ($event) {
                var regex = new RegExp("^[a-zA-Z ñÑ]+$");
                var key = String.fromCharCode(!$event.charCode ? $event.which : $event.charCode);
                if (!regex.test(key)) {
                    $event.preventDefault();
                    return false;
                }
            }
        }
    }
</script>
<style scoped>
    .slide-fade-enter-active {
        transition: all 0.45s ease;
    }
    .slide-fade-leave-active {
        transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to{
        transform: translateY(70px);
        opacity: 0;
    }
</style>

